import { getAppNames } from "single-spa";
import { useStorePagesEnabled } from "@/shared/hooks/useStorePagesEnabled";
import { usePermissions } from "shared/hooks/usePermissions";
import { SidebarRoute } from "./routes";

export const useSidebarRouteVisibility = () => {
  const storePagesEnabled = useStorePagesEnabled();
  const { hasPermission } = usePermissions();
  const appNames = getAppNames();

  return (route: SidebarRoute) =>
    hasPermission(route.permission) &&
    (!route.electronOnly || storePagesEnabled) &&
    (!route.appName || appNames.includes(route.appName));
};
